export const textBlueColor = "#215e9a";

export const blue = "#4d90d8";
export const green = "#4ea72f";
export const yellow = "#ffff00";
export const orange = "#ffc001";
export const red = "#ff0200";

export const pdfPageCss = {
  page: {
    paddingTop: 30,
    paddingBottom: 50,
    paddingLeft: 60,
    paddingRight: 40,
    fontSize: 10,
  },
  tableAndLegendContainer: {
    flexDirection: "column", // Stack tables & legend in a column
    minHeight: 500, // Ensures enough space for tables & legend
    justifyContent: "flex-start", // Aligns content to the top
  },
  tableSection: {
    maxHeight: 400, // Limits table expansion
    overflow: "hidden", // Prevents excessive pushing
  },
  section: {
    flexGrow: 1,
    paddingTop: 3,
    paddingBottom: 3,
  },
  header: {
    flexDirection: "row",
    justifyContent: "flex-end",
  },
  headerImage: {
    width: 40,
    height: 40,
    borderRadius: 15,
  },
  centeredTitle: {
    fontWeight: "bold",
    color: textBlueColor,
    fontSize: 14,
    marginBottom: 3,
    textAlign: "center",
    width: "100%",
  },
  boldText: {
    fontFamily: "Helvetica-Bold", // Use a bold font
    fontSize: 14,
  },
  title: {
    color: textBlueColor,
    fontSize: 10,
    marginTop: 3,
  },
  subTitle: {
    fontWeight: "bold",
    marginTop: 7,
    maxWidth: 160,
  },
  container: {
    flexDirection: "row",
    flexWrap: "wrap",
    justifyContent: "space-between",
    marginBottom: 10,
  },
  line: {
    marginTop: 5, // Adjust spacing from the title
    marginBottom: 5, // Adjust spacing from the next element
    width: "100%", // Full width
    height: 2, // Thin line
    backgroundColor: textBlueColor, // Line color
  },
  addSpace: {
    height: 20,
  },
  bannerImage: {
    marginTop: 5,
    marginBottom: 7,
    width: "100%", // Makes the image span the entire width
    height: 100, // Adjust as needed
  },
};
